module.exports = __webpack_public_path__ + "media/images/common/slack-logo-583f244fbc473e1e9e9221f07682eceb.svg";